import { render } from "./attachment.vue?vue&type=template&id=5926b56e"
import script from "./attachment.js?vue&type=script&lang=js&external"
export * from "./attachment.js?vue&type=script&lang=js&external"

import "./attachment.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__